import { Link } from 'react-router-dom'
import { useUser } from '../context/UserContext'
import { canUsePermissionDebug } from '../utils/permissionDebug'

const ViewAsBanner = () => {
  const { realUser, viewAs, isViewAsActive, clearViewAs } = useUser()

  if (!canUsePermissionDebug(realUser) || !isViewAsActive) return null

  const modeLabel = viewAs?.mode === 'role' ? 'tipo de usuario' : 'usuario'

  return (
    <div
      className="sticky top-12 z-30 -mx-6 mb-4 flex flex-wrap items-center justify-between gap-3 border-b border-amber-300 bg-amber-100 px-4 py-2 text-sm text-amber-950"
      role="status"
    >
      <div>
        <strong>Modo debug permisos</strong>
        {' — '}
        viendo menú y pantallas como {modeLabel}:{' '}
        <strong>{viewAs?.label || viewAs?.user?.nombre || '—'}</strong>
        {viewAs?.user?.tipo_usuario ? (
          <span className="text-amber-800"> ({viewAs.user.tipo_usuario})</span>
        ) : null}
        <span className="mt-0.5 block text-xs text-amber-800">
          Afecta menú, rutas y lo que las pantallas leen de useUser(). Tu login real no cambia (
          {realUser?.email || '—'}).
        </span>
      </div>
      <div className="flex flex-shrink-0 items-center gap-2">
        <Link
          to="/debug-permisos"
          className="rounded border border-amber-400 bg-white px-3 py-1 text-xs font-medium text-amber-900 hover:bg-amber-50"
        >
          Panel debug
        </Link>
        <button
          type="button"
          onClick={clearViewAs}
          className="rounded bg-amber-800 px-3 py-1 text-xs font-medium text-white hover:bg-amber-900"
        >
          Salir de simulación
        </button>
      </div>
    </div>
  )
}

export default ViewAsBanner
